<template>
    <div class="category">
        <div v-if="loading" class="loading"></div>
        <div class="nameC">
            <img v-if="category.icon" class="icon" :src="this.axios.defaults.baseImageURL + 'images/icons/' + category.icon" alt="">
            <img v-else class="icon" :src="this.axios.defaults.baseImageURL + 'images/icons/monitor.svg'" alt="">
            <div class="title" @click="productShowToggle">{{ category.name }}</div>
        </div>

        <banner-c
                v-if="this.productShow && this.category.stocks.length > 0"
                :pStocks="category.stocks"
        ></banner-c>

        <product-list
                :contentId="category.v1c_id"
                :contentShow="this.productShow"
                :loadingS="loading"
                @changeLoading="loading = $event"
        ></product-list>
    </div>
</template>

<script>
    import ProductList from "./ProductList";
    import BannerC from "./Banner";

    export default {
        props: ['category'],
        data() {
            return {
                productShow: false,
                loading: false,
            }
        },
        methods: {
            productShowToggle() {
                this.productShow = !this.productShow
            },

            // changeLoading(){
            //     this.loading = $event;
            // }
        },
        components: {
            ProductList,
            BannerC
        }
    }
</script>

<style >

    .nameC{
        display: flex;
        align-items: center;
        padding-left: 20px;
    }

    .icon{
        height: 25px;
        object-position: center;
        object-fit: contain;
    }

</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/Category.vue